/**
 * @file scroll事件
 */

export const preventDefault = e => {
    e = e || window.event;
    if (e.preventDefault) {
        e.preventDefault();
    }
    else {
        e.returnValue = false;
    }
};

const isFireFox = /FireFox/i.test(navigator.userAgent);

/**
 * 禁止页面滑动
 *
 */
export const notAllowScroll = () => {
    if (isFireFox) {
        document.documentElement.style.overflow = 'hidden';
    }
    else {
        document.body.style.overflow = 'hidden';
    }
    document.addEventListener('touchmove', preventDefault, false);
};


/**
 * 解绑禁止页面滚动事件
 *
 */
export const allowScroll = () => {
    if (isFireFox) {
        document.documentElement.style.overflow = 'visible';
    }
    else {
        document.body.style.overflow = 'visible';
    }
    document.removeEventListener('touchmove', preventDefault, false);
};
